export const palette = [
    "#ffd700", // 1st
    "#c0c0c0", // 2nd
    "#CD7F32", // 3rd

    // extended users (muted + distinct hues)
    "#ffbbbb", // muted blue
    "#e6c1db", // muted red
    "#add4d3", // muted orange
    "#c2c796", // muted green

    "#5a5a5a",

    "#ffec80",
    "#e0dede",
    "#e8ae74",
];